import React, { useState } from "react";
import "./BrokerPassword.css";
import badge from "../../assets/images/badge.png";
import BrokerHeader from "../BrokerHeader/BrokerHeader";
import { useLocation, useNavigate } from "react-router-dom";

const BrokerPassword = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const { state } = useLocation();
  const navigate = useNavigate();
  const broker = state?.broker;

  const handleSubmit = () => {
    if (!password) {
      setError("Please enter your password");
      return;
    }

    console.log("Submitting password");
    // API call logic here, then navigate to trading screen
    navigate(`/broker-integration/${broker?.name}/trading`, {
      state: { broker },
    });
  };

  return (
    <div className="password-wrapper">
      <div className="password-container">
        {/* Top logos section */}
        <BrokerHeader />

        {/* Main Card */}
        <div className="password-card">
          <h3 className="password-title">Connect Your Broker</h3>

          {/* Security Badge */}
          <div className="password-secure-badge">
            <img src={badge} alt="Secure Badge" />
            <span>Rest Assured, Your Data is Fully Encrypted</span>
          </div>

          {/* Password Input Section */}
          <div className="password-form-section">
            <label className="password-input-label">Enter Password</label>

            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                className="password-input"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#999999"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#999999"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>

            {error && <p className="password-error-message">{error}</p>}
          </div>

          {/* Submit Button */}
          <button
            className={`password-submit-btn ${!password ? "disabled" : ""}`}
            onClick={handleSubmit}
            disabled={!password}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrokerPassword;
